export default __webpack_public_path__ + "eb334e32cfb3bdb160123c2e66085ca6.svg";